/* ============================================================
   NH · Efectos premium Natural Hubb
   1) Reveal on scroll (IntersectionObserver)
   2) Tilt 3D sutil en imágenes de producto
   3) Micro-sonidos Web Audio (sin archivos) con botón de silencio
   4) Contadores animados [data-nh-count]
   Respeta prefers-reduced-motion. Cero librerías.
   ============================================================ */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia('(hover: none)').matches;

  /* ---------- 1) REVEAL ON SCROLL ---------- */
  function initReveal() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll(
      '.shopify-section section, .nhp-ing-card, .nhp-fit-item, .nh2-why-card, .nh2-tm-card, .nhp-review-card, .nh2-goal'
    );
    if (!targets.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('nh-revealed');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var i = 0;
    targets.forEach(function (el) {
      // No animar lo que ya está en pantalla al cargar (evita parpadeo del hero)
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) return;
      el.classList.add('nh-reveal-init');
      // Cascada sutil en grids
      el.style.transitionDelay = ((i % 4) * 60) + 'ms';
      i++;
      io.observe(el);
    });
  }

  /* ---------- 2) TILT 3D SUTIL ---------- */
  function initTilt() {
    if (reduced || isTouch) return;
    var media = document.querySelectorAll(
      '.product__media-item img, .product-media-container img, .nhp-ph img, [data-nh-tilt]'
    );
    var MAX = 5; // grados máximos — elegante, no mareo
    media.forEach(function (img) {
      var wrap = img.closest('.nh-tilt-wrap') || img.parentElement;
      if (!wrap || wrap.dataset.nhTiltDone) return;
      wrap.dataset.nhTiltDone = '1';
      wrap.classList.add('nh-tilt-wrap');
      img.classList.add('nh-tilt');
      wrap.addEventListener('pointermove', function (ev) {
        var r = wrap.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        img.style.transform = 'rotateY(' + (x * MAX) + 'deg) rotateX(' + (-y * MAX) + 'deg) scale(1.015)';
      });
      wrap.addEventListener('pointerleave', function () {
        img.style.transform = '';
      });
    });
  }

  /* ---------- 3) MICRO-SONIDOS (Web Audio, sin archivos) ---------- */
  var audioCtx = null;
  function soundOn() {
    return true; // sonido siempre activado (botón de silencio removido)
    /* eslint-disable no-unreachable */
    try { return localStorage.getItem('nhfx-sound') !== 'off'; } catch (e) { return true; }
  }
  function playTone(freqStart, freqEnd, duration, volume, type) {
    if (!soundOn()) return;
    try {
      audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
      if (audioCtx.state === 'suspended') audioCtx.resume();
      var t = audioCtx.currentTime;
      var osc = audioCtx.createOscillator();
      var gain = audioCtx.createGain();
      osc.type = type || 'sine';
      osc.frequency.setValueAtTime(freqStart, t);
      osc.frequency.exponentialRampToValueAtTime(freqEnd, t + duration);
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(volume, t + 0.012);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + duration);
      osc.connect(gain).connect(audioCtx.destination);
      osc.start(t);
      osc.stop(t + duration + 0.02);
    } catch (e) {}
  }
  var clickBlip = function () { playTone(950, 620, 0.09, 0.045, 'sine'); };
  var successChime = function () {
    playTone(660, 660, 0.12, 0.05, 'sine');
    setTimeout(function () { playTone(880, 880, 0.16, 0.05, 'sine'); }, 110);
  };

  function initSounds() {
    // Sonido SOLO en gestos del usuario (nunca al cargar la página)
    document.addEventListener('click', function (ev) {
      var t = ev.target.closest(
        '.nh-order-btn, .nh2-btn, .nhp-guar-btn, button[name="add"], .quantity-break, .sticky-atc .button'
      );
      if (!t) return;
      if (t.id === 'nh-order-submit' || t.closest('#NHOrderForm')) { successChime(); return; }
      clickBlip();
    }, { passive: true });

    // Botón flotante de silencio: REMOVIDO (sonido siempre activado, sin botón)
  }

  /* ---------- 4) CONTADORES ANIMADOS ---------- */
  function initCounters() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('[data-nh-count]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var end = parseInt(el.getAttribute('data-nh-count'), 10) || 0;
        var prefix = el.getAttribute('data-nh-prefix') || '';
        var suffix = el.getAttribute('data-nh-suffix') || '';
        var dur = 1200, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + Math.round(end * eased).toLocaleString('es-PA') + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 5) IMÁGENES DE LUJO (zoom + destello al tocar) ---------- */
  function initLuxImages() {
    var wraps = document.querySelectorAll(
      '.nh-ang-media, .nhc-media-main, .nhc-media-card, .nhp-ph, .nh2-goal-img, ' +
      '.nhp-ing-img, .nh-ugcv-card, .nhps-media, .product__media-item, .nh-ctac-product'
    );
    wraps.forEach(function (w) {
      if (w.querySelector('img') && !w.classList.contains('nh-img-lux')) {
        w.classList.add('nh-img-lux');
      }
    });
  }

  /* ---------- 6) ESCARCHA PREMIUM (partículas doradas + estrellas) ---------- */
  function initSparkles() {
    if (reduced) return;
    if (window.innerWidth < 700) return; // perf: sin sparkles en movil
    var isMobile = window.innerWidth < 700;
    var zones = document.querySelectorAll(
      '.nhc-hero, .nh-ctap, .nhp-guar, .nh2-guar, .nh-order-success, ' +
      '.nh2-stats, .nh-ctac-card, .nhp-seals, .nh2-cta, .nhp-reviews-photo'
    );
    var total = 0;
    var MAXTOTAL = isMobile ? 60 : 110;
    zones.forEach(function (zone) {
      if (zone.dataset.nhSparkled || total > MAXTOTAL) return;
      zone.dataset.nhSparkled = '1';
      var cs = getComputedStyle(zone);
      if (cs.position === 'static') zone.style.position = 'relative';
      var isHero = zone.classList.contains('nhc-hero');
      var count = isHero ? (isMobile ? 20 : 40) : (isMobile ? 8 : 15);
      for (var i = 0; i < count; i++) {
        var isStar = Math.random() < 0.3;
        var s = document.createElement('span');
        if (isStar) {
          s.className = 'nh-star';
          s.textContent = '✦';
          s.style.fontSize = (8 + Math.random() * 12) + 'px';
        } else {
          s.className = 'nh-sparkle';
          var size = 3 + Math.random() * 7;
          s.style.width = size + 'px';
          s.style.height = size + 'px';
        }
        s.style.left = (2 + Math.random() * 96) + '%';
        s.style.top = (3 + Math.random() * 90) + '%';
        s.style.setProperty('--nh-sp-dur', (3 + Math.random() * 4.5) + 's');
        s.style.setProperty('--nh-sp-delay', (Math.random() * 6) + 's');
        zone.appendChild(s);
        total++;
      }
    });
  }

  /* ---------- 7) POLVO DORADO AMBIENTAL (canvas, toda la página) ---------- */
  function initDustField() {
    if (reduced) return;
    if (window.innerWidth < 700) return; // perf: sin canvas de polvo en movil (ahorra CPU/bateria)
    var canvas = document.createElement('canvas');
    canvas.id = 'nh-dust-canvas';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var W, H, parts = [], bursts = [];
    var isMobile = window.innerWidth < 700;
    var COUNT = isMobile ? 26 : 56;

    function resize() {
      W = canvas.width = window.innerWidth;
      H = canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    function mk() {
      return {
        x: Math.random() * W,
        y: H + Math.random() * H * 0.3,
        r: 0.6 + Math.random() * 2.2,
        vy: 0.12 + Math.random() * 0.35,
        vx: (Math.random() - 0.5) * 0.15,
        o: 0.15 + Math.random() * 0.4,
        tw: Math.random() * Math.PI * 2,
        tws: 0.008 + Math.random() * 0.02,
        gold: Math.random() < 0.7
      };
    }
    for (var i = 0; i < COUNT; i++) {
      var p = mk();
      p.y = Math.random() * H; // distribuir al inicio
      parts.push(p);
    }

    var running = true;
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) requestAnimationFrame(loop);
    });

    // ★ EXPLOSIÓN DORADA al hacer clic en cualquier botón dorado
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest(
        '.nh2-btn-gold, .nhc-btn-gold, .nh-ctac-btn-gold, .nh-ctap-btn-gold, .nh-order-btn-gold, .nh-ang-cta, button[name="add"]'
      );
      if (!btn) return;
      var n = isMobile ? 12 : 20;
      for (var i = 0; i < n; i++) {
        var ang = Math.random() * Math.PI * 2;
        var spd = 1.5 + Math.random() * 3.5;
        bursts.push({
          x: ev.clientX, y: ev.clientY,
          vx: Math.cos(ang) * spd, vy: Math.sin(ang) * spd - 1.2,
          r: 1.5 + Math.random() * 3,
          life: 1, decay: 0.016 + Math.random() * 0.02,
          gold: Math.random() < 0.85
        });
      }
    }, { passive: true });

    function loop() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      // Polvo ambiental
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y -= p.vy;
        p.x += p.vx + Math.sin(p.tw) * 0.12;
        p.tw += p.tws;
        if (p.y < -8) { parts[i] = mk(); continue; }
        var alpha = p.o * (0.55 + 0.45 * Math.sin(p.tw * 2));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        if (p.gold) {
          ctx.fillStyle = 'rgba(201,162,39,' + alpha + ')';
          ctx.shadowColor = 'rgba(255,236,170,.8)';
          ctx.shadowBlur = 8;
        } else {
          ctx.fillStyle = 'rgba(250,248,242,' + alpha + ')';
          ctx.shadowColor = 'rgba(255,255,255,.6)';
          ctx.shadowBlur = 5;
        }
        ctx.fill();
        ctx.shadowBlur = 0;
      }
      // Explosiones de clic
      for (var j = bursts.length - 1; j >= 0; j--) {
        var b = bursts[j];
        b.x += b.vx; b.y += b.vy;
        b.vy += 0.06; // gravedad suave
        b.vx *= 0.985;
        b.life -= b.decay;
        if (b.life <= 0) { bursts.splice(j, 1); continue; }
        ctx.beginPath();
        ctx.arc(b.x, b.y, b.r * b.life, 0, Math.PI * 2);
        ctx.fillStyle = b.gold
          ? 'rgba(201,162,39,' + (b.life * 0.95) + ')'
          : 'rgba(255,246,214,' + (b.life * 0.95) + ')';
        ctx.shadowColor = 'rgba(255,236,170,.9)';
        ctx.shadowBlur = 10 * b.life;
        ctx.fill();
        ctx.shadowBlur = 0;
      }
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  }

  /* ---------- INIT ---------- */
  function init() {
    initReveal();
    initTilt();
    initSounds();
    initCounters();
    initLuxImages();
    initSparkles();
    initDustField();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===== NH · Compra rápida desde tarjetas de producto (data-nh-qadd) ===== */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-nh-qadd]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(btn.getAttribute('data-nh-qadd'), 10), quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        body.sections = drawer.getSectionsToRender().map(function(s){ return s.id; });
        body.sections_url = window.location.pathname;
      } catch(err) {}
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r){ return r.json(); }).then(function(res){
      if (res && res.status && res.status !== 200) { location.href = '/cart'; return; }
      btn.classList.add('nhpc-ok');
      setTimeout(function(){ btn.classList.remove('nhpc-ok'); }, 1600);
      if (drawer && res && res.sections && typeof drawer.renderContents === 'function') {
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        location.href = '/cart';
      }
    }).catch(function(){ location.href = '/cart'; })
      .finally(function(){ btn.disabled = false; });
  });

  /* ---------- Rebote "agregado" en cualquier botón de compra ---------- */
  (function(){
    var SEL = '.product-form__submit, button[name="add"], .nhpc-buy, .nh-urg-buy, .nhp-cmp-cta, .nhfg-cta, .nhcv-btn-gold, .nh2-btn-gold, [data-nh-buy], [data-nh-qadd]';
    document.addEventListener('click', function(ev){
      var b = ev.target.closest(SEL);
      if (!b) return;
      b.classList.remove('nh-justadded'); void b.offsetWidth; b.classList.add('nh-justadded');
      setTimeout(function(){ b.classList.remove('nh-justadded'); }, 650);
    }, true);
  })();
})();
